export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: (theme) => theme.spacing(0.75, 2),
    position: 'sticky',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1100,
    // eslint-disable-next-line no-restricted-syntax -- sandbox environment marker stays the same loud orange in both modes
    backgroundColor: '#FF8C00',
  },
  text: {
    fontSize: '14px',
    fontWeight: 500,
    margin: 0,
    color: 'common.white',
    textAlign: 'center',
  },
}
